export const PROFIT_LOCATION_OPTIONS = [
    {
        label: 'Front End',
        value: 'Front'
    },
    {
        label: 'Back End',
        value: 'Back'
    }
];

export const UPFRONT_OPTIONS = [
    {
        label: 'Upfront',
        value: 'Upfront'
    },
    {
        label: 'Capitalized',
        value: 'Capitalized'
    }
];

export const NON_RATEABLE_PRODUCT = 'non-rateable';

export const UNLIMITED_MILEAGE_LABEL = 'Unlimited';

export const FETCHING_RATE_FIELD_MESSAGE = '...';

export const GAP_PRODUCT_CATEGORY_CODE = 'GAP';

export enum CatalogTableColumns {
    SELECT_PRODUCT = 'selectProduct',
    PRODUCT_NAME = 'productName',
    PRODUCT_CATEGORY_CODE = 'productCategoryCode',
    PRODUCT_CODE = 'productCode',
    PRODUCT_COST = 'productCost',
    PROFIT_LOCATION = 'profitLocation',
    PRODUCT_PRICE = 'productPrice',
    ACTIONS = 'actions',
    PRODUCT_PROVIDER_NAME = 'productProviderName',
    PRODUCT_PROVIDER_PLAN = 'productProviderPlan',
    PRODUCT_COVERAGE_LENGTH = 'productCoverageLength',
    PRODUCT_COVERAGE_MILES = 'productCoverageMiles',
    PRODUCT_DEDUCTIBLE = 'productDeductible',
    MARKUP_VALUE = 'markupValue'
}

export const MANUAL_OVERRIDE_TOOLTIP =
    'Enables deal-level editing for Provider, Term Months, Term Miles, Service Interval, and Deductible. ' +
    'Changes apply to this deal only.';
